import { getTheme } from 'Utilities/dataHelpers';
import { NAVIGATION } from '../nav/types';
import { SET_PHONE_LANGUAGE } from './types';
const initialState = {
    osType: 'none',
    osVersion: 'none',
    appVersion: 'none',
    deviceId: '',
    installationId: '',
    theme: getTheme(),
    app: 'libre1',
    appHash: '',
    deviceManufacturer: 'none',
    deviceModel: 'none',
    country: '',
    phoneLanguage: '',
};
export const envReducer = (state = initialState, action) => {
    switch (action.type) {
        case NAVIGATION:
            return {
                ...state,
                osType: action.context.query?.osType || state.osType,
                osVersion: action.context.query?.osVersion || state.osVersion,
                deviceId: action.context.query?.deviceId || state.deviceId,
                installationId: action.context.query?.installationId || state.installationId,
                appVersion: action.context.query?.appVersion || state.appVersion,
                theme: action.context.query?.theme || state.theme,
                app: action.context.query?.app || state.app,
                appHash: action.context.query?.appHash || state.appHash,
                deviceManufacturer: action.context.query?.deviceManufacturer || state.deviceManufacturer,
                deviceModel: action.context.query?.deviceModel || state.deviceModel,
                country: action.context.query?.country || state.country,
            };
        case SET_PHONE_LANGUAGE:
            return {
                ...state,
                phoneLanguage: action.phoneLanguage,
            };
        default:
            return state;
    }
};
